/**
 * @author evdokimov
 */
import OldBaseFormMediator from './OldBaseFormMediator'
import ProfitLossReportEditFormConfigController from './edit_config_controller/ProfitLossReportEditFormConfigController'
import ProfitLossCSVPreviewGenerator from './preview/csv/profitloss/ProfitLossCSVPreviewGenerator'
import ProfitLossHTMLPreviewGenerator from './preview/html/profitloss/ProfitLossHTMLPreviewGenerator'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function ProfitLossFormMediator () {}

ProfitLossFormMediator.prototype = new OldBaseFormMediator();

ProfitLossFormMediator.prototype.init = function ( config ) {
    OldBaseFormMediator.prototype.init.call(this, config);
    return this;
};

ProfitLossFormMediator.prototype.initParamsStringBuilder = function ( config )
{
    return new ATReportParamsStringBuilder({
        data: {
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    })
};

ProfitLossFormMediator.prototype.initEditConfigController = function ( config ) {
    return new ProfitLossReportEditFormConfigController().init(
            {
                panelId: "mainContainer",
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: () => this.changeParametersCallback()
            } )
};

ProfitLossFormMediator.prototype.initCsvGenerator = function(){
    return new ProfitLossCSVPreviewGenerator().init();
};

ProfitLossFormMediator.prototype.initHtmlGenerator = function(){
    return new ProfitLossHTMLPreviewGenerator().init();
};




// WEBPACK FOOTER //
// ./web/js/reports/ProfitLossFormMediator.js